import React from 'react';
import PropTypes from 'prop-types';
import {logoutStart} from '@app/redux/actions';
import {connect} from 'react-redux';
import {selectAuth} from '@app/redux/selectors';
import {ConfirmComponent} from '@app/components/common/ConfirmComponent';
import {LogoutOutlined} from '@ant-design/icons';

const LogoutButton = ({auth, handleLogoutStart}: any) => {

  return (
    <ConfirmComponent
      confirmMessage={'Do you want to logout?'}
      confirmButtonType={'link'}
      onConfirm={() => handleLogoutStart(auth)}
      confirmStyle={{
        color: 'white',
        paddingLeft: 0,
        textAlign: 'left',
        flex: 1,
        // onOk: () => handleLogoutStart(auth),
      }}
    >
      <LogoutOutlined style={{lineHeight: 'inherit'}} />
            Logout
    </ConfirmComponent>
  );
};

LogoutButton.propTypes = {
  auth: PropTypes.object.isRequired,
  handleLogoutStart: PropTypes.func.isRequired,
};

const actions = {
  handleLogoutStart: logoutStart,
};

const mapState = (state: any) => {
  const auth = selectAuth(state);
  return {auth};
};

export default connect(mapState, actions)(LogoutButton);
